import { SubscriptionTick } from "~/components/icons";
import { useI18n } from "~/hooks/use-i18n";

import { Flex, Text } from "../../../components/_deprecated/primitives";
import styled, { theme } from "../../../components/theme";

const Step = styled("div")`
  display: flex;
  position: relative;
  font-weight: 600;
  flex: 1;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: ${theme.space[3]};
  margin-bottom: ${theme.space[3]};
`;

const StepLine = styled("div")<{ active: boolean }>`
  display: flex;
  border-bottom: solid 4px ${theme.colors.neutral.medium};
  position: relative;
  align-self: flex-start;
  flex: 1;
  margin-top: ${theme.space[6]};
  &:after {
    z-index: 1;
    position: absolute;
    content: "";
    transition: all 400ms cubic-bezier(0.215, 0.61, 0.355, 1);
    height: 4px;
    width: ${props => (props.active ? "100%" : 0)};
    background-color: ${theme.colors.primary.dark};
  }
`;

interface ISubscriptionStepsProps {
  step: number;
}

const SubscriptionSteps = ({ step }: ISubscriptionStepsProps) => {
  const { t } = useI18n("admin-org");
  const packageComplete = step >= 2;
  const billingComplete = step >= 3;
  const purchaseComplete = step >= 4;
  const paymentConfirmed = step >= 4;
  return (
    <Flex my="4" justifyContent="space-between">
      <Step>
        <SubscriptionTick active={packageComplete} />
        <Text mt="4" textAlign="center">
          {t("admin-org:subscriptions.upgrade.select_plan")}
        </Text>
      </Step>
      <StepLine active={packageComplete} />
      <Step>
        <SubscriptionTick active={billingComplete} />
        <Text mt="4" textAlign="center">
          {t("admin-org:subscriptions.upgrade.billing_details")}
        </Text>
      </Step>
      <StepLine active={billingComplete} />
      <Step>
        <SubscriptionTick active={purchaseComplete} />
        <Text mt="4" textAlign="center">
          {t("admin-org:subscriptions.upgrade.purchase_subscription")}
        </Text>
      </Step>
      <StepLine active={purchaseComplete} />
      <Step>
        <SubscriptionTick active={paymentConfirmed} />
        <Text mt="4" textAlign="center">
          {t("admin-org:subscriptions.upgrade.upgrade_confirmed")}
        </Text>
      </Step>
    </Flex>
  );
};

export default SubscriptionSteps;
